var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueSkeletonCircle",staticClass:"vue-skeleton-circle",style:({
    backgroundColor: _vm.backColor,
    width: _vm.diameter,
    height: _vm.diameter,
    'border-radius': '50%',
    margin: _vm.margin,
    'flex-shrink': '0',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }